import React from 'react';

import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { type AgentAction } from '@atlassian/conversation-assistant-service';

import { getAgentActionIcon } from '../../../utils/agent-actions';

const wrapperStyles = xcss({
	border: `1px solid ${token('color.border')}`,
	borderRadius: token('border.radius.100', '0.25rem'),
	padding: 'space.050',
	width: 'fit-content',
});

const pillIconStyles = xcss({
	backgroundColor: 'color.background.brand.subtlest',
	borderRadius: token('border.radius.100', '0.25rem'),
	width: '20px',
	height: '20px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const AgentActionPill = ({ action: { name, id } }: { action: AgentAction }) => {
	return (
		<Inline xcss={wrapperStyles} space="space.050">
			<Box xcss={pillIconStyles}>{getAgentActionIcon(id)}</Box>

			<Text>{name}</Text>
		</Inline>
	);
};
